import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Navbar } from 'reactstrap';
import { ScrollBarInner } from './ScrollBarInner';
import { SidebarNav } from './SidebarNav';
import { connect } from 'react-redux';

class SidebarComponent extends Component {
  toggleSidenav = () => {
    this.props.toggleSidenav();
  }

  render() {
    const { routes, logo } = this.props;
    let dashboardRoute = [];

    // if (! this.props.user || ! this.props.user.profile || ! this.props.user.profile.organizations || this.props.user.profile.organizations.length === 0 ) {
    //   dashboardRoute.push(routes[0]);
    // }

    return (
      <Navbar
        id="left-side-bar"
        aria-label="Main navigation"
        className={
          "side-bar sidenav navbar-vertical navbar-expand-xs navbar-light bg-white " +
          ( this.props.rtlActive ? '' : 'fixed-left' )
        }
      >
        {
          navigator.platform.indexOf('Win') > -1 ?
            (
              <PerfectScrollbar>
                <div className="scrollbar-inner">
                  <SidebarNav
                    logo={ logo }
                    sidenavOpen={ this.props.sidenavOpen }
                    toggleSidenav={ this.toggleSidenav }
                    match={ this.props.match }
                  />
                  <ScrollBarInner
                    routes={ dashboardRoute.length > 0 ? dashboardRoute : routes }
                    location={ this.props.location }
                    match={ this.props.match }
                    sidenavOpen={ this.props.sidenavOpen }/>
                </div>
              </PerfectScrollbar>
            ) : (
              <div className="scrollbar-inner">
                <SidebarNav
                  logo={ logo }
                  sidenavOpen={ this.props.sidenavOpen }
                  toggleSidenav={ this.toggleSidenav }
                  match={ this.props.match }
                />
                <ScrollBarInner
                  routes={ dashboardRoute.length > 0 ? dashboardRoute : routes}
                  location={this.props.location}
                  match={ this.props.match }
                  sidenavOpen={ this.props.sidenavOpen }
                />
              </div>
            )
        }
      </Navbar>
    );
  }
}

SidebarComponent.defaultProps = {
  sidenavOpen: true,
  rtlActive: false,
  toggleSidenav: () => {}
};

SidebarComponent.propTypes = {
  // function used to make sidenav mini or normal
  toggleSidenav: PropTypes.func,
  // prop to know if the sidenav is mini or normal
  sidenavOpen: PropTypes.bool,
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  // logo
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired
  }),
  // rtl active, this will make the sidebar to stay on the right side
  rtlActive: PropTypes.bool
};

const mapStateToProps = state => ({
});

const Sidebar = connect(mapStateToProps, null )(SidebarComponent);

export { Sidebar, SidebarComponent };
